export default function Hero() {
  return (
    <section id="top" className="relative flex flex-col overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20editorial%20illustration%20of%20a%20grand%20stage%20with%20a%20single%20dramatic%20spotlight%20beaming%20down%20onto%20an%20empty%20deep%20red%20velvet%20curtain%2C%20floating%20torn%20newspaper%20clippings%20and%20subtle%20crimson%20alert%20ribbons%20drifting%20in%20the%20air%2C%20soft%20cream%20and%20coral%20red%20and%20warm%20gold%20color%20palette%2C%20stylized%20minimal%20flat%20art%20with%20fine%20grain%20texture%2C%20moody%20atmospheric%20stage%20lighting%2C%20generous%20dark%20negative%20space%20in%20the%20center%20for%20readable%20text%20overlay%2C%20elegant%20print%20magazine%20editorial%20style&width=1600&height=900&seq=nvshentafang-hero-01&orientation=landscape"
          alt="舞台聚光灯与红色幕布的暖色调杂志风插画，营造塌房预警氛围"
          title="女神塌房预警 - 舞台与聚光灯背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-foreground-950/75"></div>
      </div>

      <div className="site-container relative flex min-h-[620px] md:min-h-[680px] flex-col items-center justify-center text-center py-28">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/90 px-4 py-1.5 text-xs font-semibold tracking-widest text-foreground-950 whitespace-nowrap">
          <i className="ri-voiceprint-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          预警指南 · 防塌手册 · 避雷清单
        </span>

        <h1 className="mt-6 max-w-4xl text-4xl md:text-6xl leading-tight font-black text-background-50 drop-shadow-sm">
          女神塌房，从来不是
          <span className="relative inline-block text-accent-300">
            毫无征兆
            <span className="absolute -bottom-2 left-0 right-0 h-1 bg-primary-500 rounded-full"></span>
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-background-100/95">
          从危险信号到前兆分析，我们帮你把散落在营业与传闻里的预警信息梳理成册。
          提前嗅出风险气息，远离塌房雷区，做一个清醒、从容、有分寸的吃瓜人。
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center gap-3">
          <a
            href="#checklist"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
          >
            立即自查 8 项信号
            <i className="ri-checkbox-line text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          </a>
          <a
            href="#redFlags"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-md border border-background-50/50 bg-background-50/10 px-6 py-3 text-sm font-bold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 whitespace-nowrap cursor-pointer"
          >
            看危险信号
            <i className="ri-eye-line text-base w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          </a>
        </div>

        <p className="mt-8 flex items-center gap-2 text-xs text-background-200/80">
          <i className="ri-information-line text-sm w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          本站内容为通用风险科普，不对任何真实人物作事实定性
        </p>
      </div>

      <div className="banner-strip h-2 w-full" aria-hidden="true"></div>
    </section>
  );
}